import gql from 'graphql-tag'
import { SpaceType } from '../SpaceTypeSelect/spaceTypeQueries'
import { graphql } from 'react-apollo'
import {
  BeamConcreteGrade,
  BeamMaterial,
  BeamExtra,
  FireResistance,
  Execution,
  Finishing
} from '../Workspace/Calculation/formDataQueries'

export const PROJECT_PARAMETERS_QUERY = gql`
  query ProjectParameters {
    beamConcreteGrades {
      id
      displayName
    }

    beamMaterials {
      id
      displayName
    }

    beamExtras {
      id
      displayName
    }

    spaceTypes(country: "FI") {
      id
      displayName
    }

    fireResistances {
      id
      displayName
    }

    executionTypes {
      id
      displayName
    }

    finishingTypes {
      id
      displayName
    }
  }
`

export type ProjectParametersResponse = {
  beamConcreteGrades: BeamConcreteGrade[]
  beamMaterials: BeamMaterial[]
  beamExtras: BeamExtra[]
  spaceTypes: SpaceType[]
  fireResistances: FireResistance[]
  executionTypes: Execution[]
  finishingTypes: Finishing[]
}

// Occasionally we need to be able to specify the input props
export function getWithProjectParameters<T>() {
  return graphql<ProjectParametersResponse, T>(PROJECT_PARAMETERS_QUERY, {})
}

export const withProjectParameters = graphql<ProjectParametersResponse>(
  PROJECT_PARAMETERS_QUERY,
  {}
)



// WEBPACK FOOTER //
// ./src/Components/Projects/projectParameterQueries.ts